import styled from 'styled-components';

export default styled.div`
  font-size: 21px;
  @media (max-width: ${(props) => props.theme.breakpoints.large}) {
    font-size: 18px;
  }
`;
